import React from "react";
import { Link } from "react-router-dom";

const Commercial = () => (
  <div data-testid="commercial-page">
    <section className="bg-navy text-white py-24 relative overflow-hidden">
      <img src="https://images.pexels.com/photos/27634071/pexels-photo-27634071.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="overline text-gold">Commercial</div>
        <h1 className="font-display text-4xl lg:text-6xl mt-4 max-w-3xl">Office, retail, and investment-grade assets.</h1>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-3 gap-6">
      {[
        { t: "Buy Commercial", d: "Class A office, retail, industrial — advisory from sourcing through close.", cta: "View acquisitions", link: "/listings?category=commercial" },
        { t: "Lease Commercial", d: "Tenant and landlord representation with institutional discipline.", cta: "Leasing inquiry", link: "/contact" },
        { t: "Investment", d: "Stabilized and value-add opportunities for family office and institutional capital.", cta: "Confidential brief", link: "/contact" },
      ].map((c) => (
        <div key={c.t} className="bg-white border border-slate-200 p-10" data-testid={`commercial-card-${c.t.toLowerCase().replace(/\s/g, "-")}`}>
          <div className="overline text-gold">Service</div>
          <h3 className="font-display text-2xl text-navy mt-3">{c.t}</h3>
          <p className="mt-4 text-slate-600 leading-relaxed">{c.d}</p>
          <Link to={c.link} className="btn-navy mt-8 inline-flex">{c.cta}</Link>
        </div>
      ))}
    </section>

    <section className="bg-navy text-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12">
        <div>
          <div className="overline text-gold">Investment Desk</div>
          <h2 className="font-display text-3xl lg:text-4xl mt-3">Curated opportunities, under NDA.</h2>
          <p className="mt-6 text-white/75 leading-relaxed">Our Investment Desk circulates select off-market deals to qualified family offices, institutional investors, and operating partners.</p>
          <Link to="/contact" className="btn-gold mt-8 inline-flex" data-testid="commercial-invest-cta">Request Access</Link>
        </div>
        <img src="https://images.pexels.com/photos/962984/pexels-photo-962984.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="w-full h-80 object-cover" />
      </div>
    </section>
  </div>
);

export default Commercial;
